import React, { memo } from "react";
import "./style.css";

interface IProgressBarProps extends React.HTMLAttributes<HTMLDivElement> {
  progress: number;
}

const ProgressBar = memo(({ progress, ...rest }: IProgressBarProps) => {
  return (
    <div className="progress-container">
      <div
        className="progress-bar"
        style={{ width: `${progress || 1}%` }}
        {...rest}
      />
    </div>
  );
});

export default ProgressBar;
